import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ArrowRightIcon } from "lucide-react";
import Tabs from "../../components/tabs/Tabs";

const Settings = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [initialTab, setInitialTab] = useState<string | null>(null);

  useEffect(() => {
    const tabParam = searchParams.get('tab');
    if (tabParam) {
      setInitialTab(tabParam);
    }
  }, [searchParams]);

  return (
    <div className="flex flex-col min-h-screen rounded-lg shadow-lg bg-gray-50 sm:flex-row">
      <div className="flex-1 p-4 sm:p-6">
        {/* Header */}
        <h1 className="mb-4 text-xl font-bold text-gray-800 sm:text-2xl">
          Settings
        </h1>

        {/* Tabs */}
        <Tabs 
          initialTab={initialTab} 
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />

        {/* Beta Feedback */}
        <a
          href={process.env.REACT_APP_BETA_FEEDBACK_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="block no-underline"
        >
          <div className="flex flex-col items-start max-w-3xl gap-3 p-3 mt-4 border border-blue-200 rounded-lg bg-blue-50 sm:p-4 sm:flex-row sm:justify-between sm:items-center sm:gap-0 hover:bg-blue-100 transition-colors cursor-pointer">
            <div>
              <p className="text-sm font-semibold text-blue-600 sm:text-base">
                Beta Feedback
              </p>
              <p className="text-xs text-blue-600 sm:text-sm">
                Help us improve! Share your thoughts on this setting.
              </p>
            </div>
            <ArrowRightIcon className="w-5 h-5 text-blue-600 sm:w-6 sm:h-6" />
          </div>
        </a>
      </div>
    </div>
  );
};

export default Settings;